import { createContext, useContext } from 'react'

// AuthContext + useAuth live in their own module so AuthContext.jsx can
// export ONLY the AuthProvider component. React Fast Refresh requires a
// module that exports a component to export *only* components — mixing
// in a hook (or any non-component export) silently disables Fast Refresh
// and Vite falls back to full-page reloads, which dumps the in-memory
// session before getSession() can resolve. That cascade is what was
// killing dev sessions.

export const AuthContext = createContext({})

export const useAuth = () => useContext(AuthContext)
